<template>
  <logged-in-layout>
    <main>
      <p :class="$style.error">{{errorMessage}}</p>
    </main>
  </logged-in-layout>
</template>

<script>
  import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'

  export default {
    components: { LoggedInLayout },
    computed: {
      errorMessage () {
        return decodeURIComponent(this.$route.query.error)
      }
    }
  }
</script>

<style module lang="less" src="./error-page.less"></style>



// WEBPACK FOOTER //
// error-page.vue?3f5c2787